export default "__VITE_ASSET__BP81lWP6__"